module.exports = __webpack_public_path__ + "img/hr-rail-endings-background.3f71d0f5.png";